// extracted by mini-css-extract-plugin
export default {"shareButtonContainer":"shareButtonContainer__MDQwM","icon":"icon__ZjkwN","transparentButton":"transparentButton__MTYwY","shareButtonCompact":"shareButtonCompact__ZTcyZ"};